import React from "react";
import { Images } from "../controller/Images";

export class ServerMaintenance  extends React.Component {
    render() {
        return (
            <div id="main-content">
                <div className="block-header">
                    <div className="col-xs-12 clearfix text-center">
                        <div className="card error-server-div">
                            <div className="card-header">
                                <img alt="Ab Environment Logo" className="img-fluid logo" src={Images.image_logo} />
                            </div>
                            <h3>MAINTENANCE</h3>
                            <p>Sorry, we are doing a little maintenance on the site to improve it.</p>
                            <h4>We will be back shortly.</h4>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/pages/ServerMaintenance.jsx